import { SOURCE } from '@laigu/constants';

const { open } = SOURCE;

const dealData = (data, type) => {
  const obj = {};
  data.forEach(x => {
    if (x.value == 'appsdk') obj.sdk = 'SDK';
    else obj[x.value] = x.label;
  });
  if (type == 'source_types') {
    obj.web = '网站';
  } else if (type == 'search_source_types') {
    obj.web = '网站';
    obj.baidu_web = '百度';
  }
  return obj;
};

const source_types = dealData(open, 'source_types');

// const source_types = {
//   weixin: '微信公众号',
//   weibo: '微博',
//   sdk: 'SDK',
//   web: '网站',
//   toutiao: '头条',
//   baidu_bcp: '百度BCP',
//   mini_program: '小程序',
//   kuaishou: '快手',
//   douyin: '抖音',
//   toutiao_microapp: '抖音小程序',
//   toutiaosearch: '今日头条'
// };

const source_icon = {
  weixin: 'https://res.wx.qq.com/a/wx_fed/assets/res/NTI4MWU5.ico',
  weibo: 'https://weibo.com/favicon.ico',
  sdk: '',
  web: '',
  toutiao: 'https://www.toutiao.com/favicon.ico',
  baidu_bcp: 'https://www.baidu.com/favicon.ico',
  mini_program: '',
  kuaishou: 'https://www.kuaishou.com/favicon.ico',
  douyin: 'https://www.douyin.com/favicon.ico',
  toutiao_microapp: 'https://www.douyin.com/favicon.ico',
  '360search': 'https://www.so.com/favicon.ico',
  baidu: 'https://www.baidu.com/favicon.ico',
  google: 'https://www.google.com/favicon.ico',
  sogou: 'https://sougou.com/favicon.ico',
  sm: 'https://m.sm.cn/favicon.ico',
  haosou: '',
  bing: 'https://cn.bing.com/favicon.ico',
  wechat: 'https://res.wx.qq.com/a/wx_fed/assets/res/NTI4MWU5.ico',
  'sm.cn': 'https://m.sm.cn/favicon.ico',
  duckduckgo: 'https://duckduckgo.com/favicon.ico',
  yahoo: 'https://search.yahoo.com/favicon.ico',
  redbook: 'https://www.xiaohongshu.com/favicon.ico',
  wx_video: 'https://www.weixin.qq.com/favicon.ico'
};

//因为打点错误 baidu_web 其实是web下面的数据 显示不存在它了  但是查询的时候需要查它 并把他的数据分均到web下面的对应类型中
const search_source_types = dealData(open, 'search_source_types');
// const search_source_types = {
//   weixin: '微信公众号',
//   weibo: '微博',
//   sdk: 'SDK',
//   web: '网站',
//   toutiao: '头条',
//   baidu_bcp: '百度BCP',
//   baidu_web: '百度',
//   mini_program: '小程序',
//   kuaishou: '快手',
//   douyin: '抖音',
//   toutiao_microapp: '抖音小程序',
//   toutiaosearch: '今日头条'
// };

const useClues = () => {
  return { source_types, search_source_types, source_icon };
};

export default useClues;
